<template>
  <div class="flex flex-col gap-3 p-3">
    <BaseShowEditSwitch
      v-model="localPrintSettings.show_remarks"
      name="show_remarks"
      :label="$t('attributes.remarks')"
      :edition-mode="true"
    />
  </div>
</template>

<script>
import BaseShowEditSwitch from '@c/BaseShowEditSwitch.vue'

export default {
  name: 'PaymentPrintOptionsMenu',
  components: {
    BaseShowEditSwitch
  },
  props: {
    printSettings: {
      type: Object,
      required: true
    }
  },
  emits: ['update:print-settings'],
  computed: {
    localPrintSettings: {
      get() {
        return this.printSettings
      },
      set(value) {
        this.$emit('update:print-settings', value)
      }
    }
  }
}
</script>